module.exports = __webpack_public_path__ + "img/smart-dent-menu-logo.51c6a786.png";